import parent from '@/store/interfaces/historicalGeneric'
const mystore = parent({ tipoEvento: 'cliente', namespaced: true })

export default mystore
